var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomersCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 46 46",
    style: {
      enableBackground: "new 0 0 46 46"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "customerCircle1GE",
    d: "M23,42.7c-10.9,0-19.7-8.9-19.7-19.7S12.1,3.5,23,3.5s19.6,8.8,19.6,19.6S33.8,42.7,23,42.7z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "customerCircle2GE",
    cx: 1.1,
    cy: 23,
    r: 1.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "customerCircle2GE",
    cx: 44.9,
    cy: 23,
    r: 1.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "customerCircle2GE",
    cx: 2.3,
    cy: 15.4,
    r: 1.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "customerCircle2GE",
    cx: 43.7,
    cy: 15.4,
    r: 1.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "customerCircle2GE",
    cx: 7.1,
    cy: 7.7,
    r: 1.1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "customerCircle2GE",
    cx: 38.9,
    cy: 7.7,
    r: 1.1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "customerCircle2GE",
    cx: 14.2,
    cy: 2.8,
    r: 1.1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "customerCircle2GE",
    cx: 31.6,
    cy: 2.8,
    r: 1.1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "customerCircle2GE",
    cx: 2.3,
    cy: 30.7,
    r: 1.1
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    className: "customerCircle2GE",
    cx: 43.7,
    cy: 30.7,
    r: 1.1
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    className: "customerCircle2GE",
    cx: 7.1,
    cy: 38.3,
    r: 1.1
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "customerCircle2GE",
    cx: 38.9,
    cy: 38.3,
    r: 1.1
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "customerCircle2GE",
    cx: 14.2,
    cy: 43.3,
    r: 1.1
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "customerCircle2GE",
    cx: 31.6,
    cy: 43.3,
    r: 1.1
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "customerCircle2GE",
    cx: 23,
    cy: 1.1,
    r: 1.1
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "customerCircle2GE",
    cx: 23,
    cy: 44.9,
    r: 1.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "customerCircle3GE",
    d: "M29.6,31.4h4.9v-3.1c-0.1-1.1-0.9-1.9-2.3-2.2l-4-0.5l-0.1,0.8l4,0.5c0.5,0.1,1.6,0.4,1.6,1.4l0.1,2.2h-4.2 L29.6,31.4L29.6,31.4L29.6,31.4z M26.5,19c0.4-0.5,1-0.6,1.6-0.6s1.1,0.3,1.6,0.6c0.4,0.4,0.5,0.8,0.5,1.4c0,0.2-0.2,1-0.3,1.6 c-0.1,0.4-0.5,1.8-1.8,1.8c-1.1,0-1.6-0.9-1.7-1.8c-0.1-0.5-0.3-1.4-0.3-1.6C25.9,19.9,26.1,19.4,26.5,19L26.5,19L26.5,19z M25.5,22 c0.3,1.5,1.3,2.5,2.6,2.5s2.3-0.9,2.6-2.5c0-0.3,0.3-1.4,0.3-1.6c0-0.7-0.3-1.5-0.7-1.9c-0.5-0.5-1.4-0.9-2.1-0.9s-1.6,0.4-2.1,0.9 c-0.5,0.5-0.7,1.2-0.7,1.9C25.2,20.7,25.4,21.9,25.5,22z M12.3,30.5l0.2-2.5c0.1-0.9,1.2-1.6,2-1.7l4.8-0.6l4.8,0.6 c0.6,0.1,2,0.5,2.1,1.8l0.2,2.4C26.5,30.5,12.3,30.5,12.3,30.5z M24.5,25.4l-5-0.6l-5,0.6c-1.2,0.3-2.6,1.1-2.7,2.5l-0.2,3.4h15.9 L27.2,28C27.1,26.7,26.1,25.8,24.5,25.4L24.5,25.4z M17.4,16.6c0.5-0.5,1.3-0.8,2-0.8s1.5,0.3,2,0.8c0.5,0.5,0.7,1.1,0.6,1.8 c0,0.2-0.2,1.4-0.4,2c-0.2,1.1-0.9,2.4-2.3,2.4s-2.2-1.3-2.4-2.4c-0.1-0.6-0.4-1.7-0.4-2C16.7,17.7,17,17,17.4,16.6L17.4,16.6z  M16.3,20.5c0.4,1.8,1.6,3,3.1,3s2.7-1.2,3.1-3c0.1-0.3,0.4-1.7,0.4-2.1c0-0.9-0.3-1.7-0.9-2.4c-0.6-0.7-1.6-1.1-2.6-1.1 c-1,0-1.9,0.4-2.6,1.1c-0.6,0.6-0.9,1.5-0.9,2.4C16,18.8,16.3,20.3,16.3,20.5L16.3,20.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersCircle);
export default __webpack_public_path__ + "static/media/customers-circle .fb38dfe0ba0757186f88fe124d82f3dd.svg";
export { ForwardRef as ReactComponent };